import { createStore, createHook, createActionsHook } from 'react-sweet-state';

const Store = createStore({
	initialState: {
		hasLivePageChanges: false,
	},
	actions: {
		setHasLivePageChanges:
			(hasLivePageChanges: boolean) =>
			({ setState }) => {
				setState({ hasLivePageChanges });
			},
	},
	name: 'live-page-invite-nudge-store',
});

export const useLivePageInviteNudgeStore = createHook(Store);
export const useLivePageInviteNudgeActions = createActionsHook(Store);
